var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 51.32 71.5"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#5ce0b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.794 0v46.122H19.639V0zM0 33.555v16.206l24.083 21.654V55.987ZM51.32 49.847V33.64L27.24 56.073v15.428Z"
  }))));
};
export default SvgArrow;